import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { path: String }
  static targets = ["label"]

  copyWithExecCommand(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "-9999px"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)
    const copied = document.execCommand("copy")
    textarea.remove()
    return copied
  }

  async copy() {
    const shareUrl = `${window.location.origin}${this.pathValue}`
    const originalLabel = this.labelTarget.textContent

    const showCopied = () => {
      this.labelTarget.textContent = "Copied!"
      setTimeout(() => {
        this.labelTarget.textContent = originalLabel
      }, 1200)
    }

    const showFailed = () => {
      this.labelTarget.textContent = "Copy failed"
      setTimeout(() => {
        this.labelTarget.textContent = originalLabel
      }, 1200)
    }

    try {
      if (navigator.share) {
        try {
          await navigator.share({ url: shareUrl, title: document.title })
          return
        } catch (error) {
          if (error?.name === "AbortError") return
        }
      }

      if (window.isSecureContext && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareUrl)
        showCopied()
        return
      }

      if (this.copyWithExecCommand(shareUrl)) {
        showCopied()
        return
      }
    } catch (_error) {
      if (this.copyWithExecCommand(shareUrl)) {
        showCopied()
        return
      }

      showFailed()
    }
  }
}
